var Reverb = window.Reverb || {};
Reverb.RefundRequests = (function () {
  function init() {
    $(document).on('click', '[name=\'order_refund_request[refund_type]\']', function () {
      $('[data-refund-type]').hide();
      $('[data-refund-type=\'' + $(this).val() + '\']').fadeIn();
    });

    $(document).on('click', '[data-refund-request-type-partial]', function () {
      $('[data-issue-refund-now]').prop('checked', true);
    });

    $(document).on('click', '[data-refund-request-type-full]', function () {
      $('[data-issue-after-item-returned]').prop('checked', true);
    });
  }

  return {
    init: init
  };
})();

$(document).ready(function () {
  Reverb.RefundRequests.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dashboard/selling/refund_requests.js